import { CurrencyCode, DEFAULT_CURRENCY } from '@/shared/constants/currencies';
import { PriceExcludingWildMembership } from '@/shared/types/prices';
import { GamePriceDataResponse } from '@/features/games/shared/types/game-data';
import { mapGamePrices } from '@/features/games/shared/helpers/map-game-prices';

type MapGameCardPricesOptions = {
  currencyCode?: CurrencyCode | null;
  isMember?: boolean;
};

export function mapGameCardPrices(
  raw: GamePriceDataResponse | undefined,
  { currencyCode = DEFAULT_CURRENCY, isMember = false }: MapGameCardPricesOptions = {},
): PriceExcludingWildMembership[] {
  if (!raw?.prices) {
    return [];
  }

  const resolvedCurrency = (currencyCode ?? DEFAULT_CURRENCY) as CurrencyCode;

  const mapped = mapGamePrices(raw, isMember, resolvedCurrency).buy ?? [];

  const prices: PriceExcludingWildMembership[] = mapped.map((price) => ({
    type: price.type as PriceExcludingWildMembership['type'],
    value: price.value,
    previousValue: price.previousValue,
    currencyCode: price.currencyCode,
  }));

  const baseValue = raw.prices.floor?.[resolvedCurrency];
  if (typeof baseValue === 'number') {
    prices.push({
      type: 'base',
      value: baseValue,
      currencyCode: resolvedCurrency,
    });
  }

  return prices;
}
